export const EventMap: Record<string, string> = {
  ProductClicked: 'redventures.ecommerce.v1.ProductClicked',
  ProductLoaded: 'redventures.ecommerce.v1.ProductLoaded',
  ProductViewed: 'redventures.ecommerce.v1.ProductViewed',
  ElementClicked: 'redventures.usertracking.v3.ElementClicked',
  ElementViewed: 'redventures.usertracking.v3.ElementViewed',
  FieldSelected: 'redventures.usertracking.v3.FieldSelected',
  FormSubmitted: 'redventures.usertracking.v3.FormSubmitted',
  FormViewed: 'redventures.usertracking.v3.FormViewed',
  ConversionTracked: 'core.conversions.ConversionTracked.v2',
};

export type EventName = keyof typeof EventMap;
